import React from 'react';
import { request } from '../../functions/apiRequestHelper';
import API from '../../functions/api';
import { formatPostcode } from '../../functions/textFormatting';
import { parse as phoneParse, getPhoneCode } from 'libphonenumber-js';
import { gtmPush } from '../../functions/gtm';
import TextField from '../../audi-ui-components/TextField';
import Select from '../../audi-ui-components/Select';
import NavBar from '../../audi-ui-components/NavBar';
import { SecondaryButton } from '../../audi-ui-components/Button';
import Spinner from '../../audi-ui-components/Spinner';
import IconPoi from '../../audi-ui-components/icons/Poi';
import IconDistance from '../../audi-ui-components/icons/Distance';
import IconList from '../../audi-ui-components/icons/List';
import SearchResult from './SearchResult';
import Map from '../locate/components/Map';
import _find from 'lodash/find';
import {
    PATH_XTIME
} from '../../constants';

import { connect } from 'react-redux';
import {
    fetchSuburbsByPostcode
} from '../../redux/Dealers';
const mapStateToProps = state => {
    return {
        suburbsByPostcode: state.dealers.suburbsByPostcode,
        isLoadingSuburbs: state.dealers.isLoadingSuburbs
    };
}
const mapDispatchToProps = dispatch => {
    return {
        fetchSuburbsByPostcode: (p, cb, errCb) => {dispatch(fetchSuburbsByPostcode(p, cb, errCb));}
    }
}

// (https://en.wikipedia.org/wiki/Haversine_formula)
const getDistance = function(locA, locB) {
    if(locA && locB) {
        //Returns Distance between two latlng objects using haversine formula
        var R = 6371; // Radius of the Earth in m
        var dLat = (locB.latitude - locA.latitude) * Math.PI / 180;
        var dLon = (locB.longitude - locA.longitude) * Math.PI / 180;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(locA.latitude * Math.PI / 180) * Math.cos(locB.latitude * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d;
    } else {
        // return a large number if either location is not valid
        return 100000000;
    }
}

class DealerSearch extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            postcode: "",
            pcError: null,
            suburb: "",
            geoResults: [],
            geoCoords: null,
            pcResults: [],
            isUsingGeo: false,
            isLoading: false,
            hasGeoError: false,
            mapDealer: null,
            viewIdx: 0
        }
    }

    fetchDealersBySuburb = (suburbId, cb, errorCb) => {
        if (!suburbId) { return; }
        API.post(
          process.env.RAZZLE_GQLAPI,
          {
            query: /* GraphQL */`query ($suburbId: Int!, $filter: LocationDtoFilterInput) {
              locationsBySuburb(skip: 0, take: 3, suburbId: $suburbId, where: $filter) {
                items {
                  id
                  locationId
                  name
                  address
                  suburb
                  postcode
                  state
                  webKey
                  phone
                  latitude
                  longitude
                  mapsURL
                  dealer {
                    dealerCode
                    dealerId
                    status
                    name
                    phone
                  }
                }
              }
            }`,
            variables: {
              suburbId: parseInt(suburbId),
              filter: {type: {eq: "Service"}, status: {eq: true}}
            }
          }
        ).then(response => {
            let items = response.data?.data?.locationsBySuburb?.items;
            if (items && typeof cb === "function") {
                cb(items);
            } else {
              if (typeof errorCb === "function") {
                  errorCb();
              }
            }
        }).catch(error => {
            if (typeof errorCb === "function") {
                errorCb(error);
            }
        });
    }

    handleChangePostcode = (v) => {
        v = formatPostcode(v);
        this.setState({postcode: v, pcError: null, suburb: "", isUsingGeo: false, hasGeoError: false, mapDealer: null});
        if (/^\d{4}$/.test(v)) {
            // get suburbs
            this.props.fetchSuburbsByPostcode(
              v,
              (suburbs) => {
                // console.log(suburbs);
                if (suburbs && suburbs.length === 1 && suburbs[0].value) {
                  this.handleChangeSuburb(suburbs[0].value);
                }
              },
              (err) => {
                this.setState({pcError: "We couldn't find any suburbs for that postcode"});
              }
            );
        }
    }

    handleChangeSuburb = (v) => {
        this.setState({suburb: v, isLoading: true, isUsingGeo: false, hasGeoError: false, mapDealer: null});
        document.querySelector(".dealer-search__results").scrollIntoView({behavior: "smooth"});
        this.fetchDealersBySuburb(
            v,
            (list) => {
                this.setState({pcResults: list, isLoading: false});
            }
        );
        // thneed.trigger('dealerServiceSearch', 'Search', {action: 'Search', postcode: this.state.postcode, suburb: v}, true);
        gtmPush("dealerServiceSearch", "search", "dealerServiceSearch", {postcode: this.state.postcode, suburb: v});
    }

    handleClickLocate = () => {
        // thneed.trigger('dealerServiceSearch', 'LocateOneNearYou', {action: 'LocateOneNearYou'}, true);
        gtmPush("dealerServiceSearch", "locateOneNearYou", "dealerServiceSearch");
        this.setState({
            hasGeoError: false,
            postcode: "",
            suburb: "",
            isLoading: true,
            isUsingGeo: true,
            mapDealer: null
        });
        navigator.geolocation.getCurrentPosition(
            (pos) => { // success
                console.log("geolocation", pos);
                document.querySelector(".dealer-search__results").scrollIntoView({behavior: "smooth"});
                API.post(
                  process.env.RAZZLE_GQLAPI,
                  {
                    query: /* GraphQL */`query ($filter: LocationDtoFilterInput) {
                      locationList(skip: 0, take: 50, where: $filter) {
                        items {
                          id
                          locationId
                          name
                          address
                          suburb
                          postcode
                          state
                          webKey
                          phone
                          latitude
                          longitude
                          mapsURL
                          dealer {
                            dealerCode
                            dealerId
                            status
                            name
                            phone
                          }
                        }
                      }
                    }`,
                    variables: {
                      filter: {type: {eq: "Service"}, status: {eq: true}}
                    }
                  }
                ).then(response => {
                    let items = response.data?.data?.locationList?.items;
                    let r = this.filterByLocation(items, pos.coords.latitude, pos.coords.longitude);
                    // console.log("geoResults", r);
                    this.setState({geoResults: r, geoCoords: pos.coords, isLoading: false});
                }).catch(error => {
                    console.error("geo query error", error);
                    this.setState({hasGeoError: true, isLoading: false});
                });
            },
            (error) => { //fail
                console.error("geo error", error);
                this.setState({hasGeoError: true, isLoading: false});
            }
        );
    }
    
    getMarkers = (results) => {
      let m = [];
      if (this.state.mapDealer !== null) {
        m = [{
          lat: parseFloat(this.state.mapDealer.latitude),
          lng: parseFloat(this.state.mapDealer.longitude),
          icon: 'mediumRed'
        }]
      } else {
        m = results.map((loc) => {
          return {
            lat: parseFloat(loc.latitude),
            lng: parseFloat(loc.longitude),
            icon: 'mediumBlack',
            onClick: ()=>{
              this.setState({mapDealer: loc});
              document.querySelector(".dealer-search__results").scrollIntoView({behavior: "smooth", block: "end"});
            }
          };
        });
        if (this.state.isUsingGeo && this.state.geoCoords) {
          m.push({
            lat: parseFloat(this.state.geoCoords.latitude),
            lng: parseFloat(this.state.geoCoords.longitude),
            icon: 'geoPos'
          });
        }
      };
      return m;
    }

    filterByLocation = (list, lat, long) => {
        let userLocation = {latitude: lat, longitude: long};
        let distances = {};
        for (let i=0; i<list.length; i++) {
            let loc = list[i];
            let distance = getDistance(userLocation, loc);
            distances[`${loc.id}`] = distance;
        }
        let iDs = Object.keys(distances);
        iDs.sort(function(a, b) {
            return distances[a] - distances[b];
        });
        let sorted = [];
        for (let i=0; i<3; i++) {
            let d = _find(list, {id: iDs[i]});
            sorted.push(d);
        }
        return sorted;
    }

    render() {
        const {suburbsByPostcode} = this.props;
        const {postcode, suburb, isUsingGeo, mapDealer, viewIdx} = this.state;
        var isLoading = this.state.isLoading || this.props.isLoadingDealersBySuburb;
        var results = null;
        if (isUsingGeo) {
            results = this.state.geoResults;
        }
        if (!isUsingGeo && suburb) {
            results = this.state.pcResults;
        }
        return (
            <div className="dealer-search pb-5">

                <div className="dealer-search__form">
                    <div className="row">
                        <div className="col-12 col-medium-6 col-large-7 mb-3">
                            <div className="row">
                                <div className="col-12 col-small-6">
                                    <TextField name="postcode"
                                        value={postcode}
                                        label="Enter your postcode"
                                        onChange={this.handleChangePostcode}
                                        isInvalid={Boolean(this.state.pcError)}
                                        invalidMessage={this.state.pcError}
                                    />
                                </div>
                                <div className="col-12 col-small-6">
                                    <Select name="suburb"
                                        value={suburb}
                                        label="Select your suburb"
                                        description={this.props.isLoadingSuburbs ? "Loading suburbs..." : null}
                                        options={postcode && suburbsByPostcode[postcode] ? suburbsByPostcode[postcode] : []}
                                        onChange={this.handleChangeSuburb}
                                        disabled={!/^\d{4}$/.test(postcode)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-medium-6 col-large-5">
                            <div className="row" style={{justifyContent: 'space-evenly'}}>
                                <div className="col-12 col-medium text-medium-center mb-3">
                                    <span className="aui-button">Or</span>
                                </div>
                                <div className="col-12 col-medium-auto mb-3">
                                    <SecondaryButton label="Locate one near you" onClick={this.handleClickLocate} icon={<IconPoi small />} iconPosition="right" />
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="dealer-search__results mb-5">
                    {isLoading || results?.length > 0 && <hr className="dealer-search__divider" />}
                    {isLoading && <div className="spinner-wrapper sticky"><Spinner isContinuous /></div>}
                    {!isLoading && results?.length === 0 && <p>no results found</p>}
                    {this.state.hasGeoError && <p className="aui-color-text-red">Sorry, we can{`'`}t find your location right now.</p>}
                    {!isLoading && results?.length > 0 && <>
                      <div className="mb-3">
                        <NavBar actions={[{text: <><IconList small /> List View</>}, {text: <><IconDistance small /> Map View</>}]} onActionClick={(i) => { this.setState({viewIdx: i}); }} activeIndex={viewIdx} />
                      </div>
                      {viewIdx === 0 && results.map((loc, i) => {
                        return (
                            <SearchResult
                                key={loc.id}
                                {...loc}
                                onClickBook={() => {
                                  console.log("onClickBook", loc.dealer.dealerCode);
                                  this.props.onSelectDealer(loc);
                                  this.props.history.push(`${PATH_XTIME}/${loc.dealer.dealerCode}/${loc.locationId}`);
                                }}
                            />
                        );
                      })}
                      {viewIdx === 1 && <div className="dealer-search__map">
                        <Map
                          markers={this.getMarkers(results)}
                          animateMarkers={false}
                          showBlurState
                          padBottom
                          selectedId={mapDealer ? mapDealer.dealer.dealerId : "none"}
                          apiKey={process.env.RAZZLE_GOOGLE_MAPS_API_KEY}
                          theme="light"
                        />
                        {mapDealer && <SearchResult {...mapDealer} onClickBook={() => { this.props.history.push(`${PATH_XTIME}/${loc.dealer.dealerCode}/${loc.id}`); }} onClickClose={()=>{ this.setState({mapDealer: null}); }} />}
                      </div>}
                    </>}
                </div>

            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DealerSearch);
